import QuestionRoot, { Props } from './Question'

export default function Question(props: Props) {
  return <QuestionRoot {...props} />
}
